export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-book-b7c68b061a261246b2b6ce6823370719.svg";